module.exports = __webpack_public_path__ + "static/media/UserIcon_1.444c6404.png";